<template>
  <div class="tonglan">
    <div class="xwlb">
      <div id="lbl" class="lbl">
        <div class="dbti" id="conent">
          <h1 style="text-align: center; height: 40px; padding-top: 25px">
            新手入门
          </h1>
          <h2 style="height: 30px"></h2>
          <p id="con"></p>

          <p class="MsoNormal" style="text-align: left">&emsp;&emsp;<br /></p>
          <p class="MsoNormal" style="text-align: left">&emsp;&emsp;<br /></p>
          <p class="MsoNormal" style="text-align: left">
            &emsp;&emsp;<b
              ><span style="font-size: 14px"
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;新手入门</span
              ><span></span
            ></b>
          </p>
          <p class="MsoNormal" style="text-align: left">
            &emsp;&emsp;<b
              ><span style="font-size: 14px"
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
              ></b
            ><span style="font-size: 14px">APP操作流程</span><span></span>
          </p>
          <p class="MsoNormal" style="text-align: left">
            &emsp;&emsp;<span style="font-size: 16px"
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;一、如何下载</span
            ><span style="font-size: 16px">APP</span>
          </p>
          <p class="MsoNormal" style="text-align: left; text-indent: 19pt">
            &emsp;&emsp;<span style="font-size: 14px"
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;打开手机应用商城</span
            ><span style="font-size: 14px">/</span
            ><span style="font-size: 14px"
              >浏览器，点击扫一扫功能，在框内扫描下方二维码，按照步骤即可安装</span
            ><span style="font-size: 14px">APP.</span>
          </p>
          <p class="MsoNormal" style="text-align: left">
            &emsp;&emsp;<b
              ><span style="font-size: 14px"
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.</span
              ></b
            ><b
              ><span style="font-size: 14px">扫码下载</span
              ><span style="font-size: 14px">:</span></b
            >
          </p>
          <p class="MsoNormal" style="text-align: left; text-indent: 19pt">
            &emsp;&emsp;<span style="font-size: 14px"
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;终端会员采购系统</span
            ><span style="font-size: 14px">:</span
            ><span
              >&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
              &nbsp;</span
            ><img
              src="https://www.yaojuduo.com/HyeyUserModule/UploadFiles/image/20190415/20190415113319_6962.jpg"
              alt=""
            /><span
              >&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
              &nbsp; &nbsp;</span
            ><img
              src="https://www.yaojuduo.com/HyeyUserModule/UploadFiles/image/20190415/20190415113233_6006.jpg"
              alt=""
            />
          </p>
          <p class="MsoNormal" style="text-align: left; text-indent: 21pt">
            &emsp;&emsp;<span
              >&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
              &nbsp; 安卓版下载&nbsp;&nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
              &nbsp; &nbsp; &nbsp;苹果版下载</span
            >
          </p>
          <p class="MsoNormal" style="text-indent: 21pt">
            &emsp;&emsp;<span></span>
          </p>
          <p class="MsoNormal" style="text-align: left; text-indent: 21pt">
            &emsp;&emsp;<span style="font-size: 14px"
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;业务员专用采购系统</span
            ><span style="font-size: 14px"
              >:&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span
            ><img
              src="https://www.yaojuduo.com/HyeyUserModule/UploadFiles/image/20190415/20190415113425_5390.jpg"
              alt=""
            /><span
              >&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
              &nbsp; &nbsp;</span
            ><img
              src="https://www.yaojuduo.com/HyeyUserModule/UploadFiles/image/20190415/20190415113451_4105.jpg"
              alt=""
            />
          </p>
          <p class="MsoNormal" style="text-align: left; text-indent: 21pt">
            &emsp;&emsp;<span
              >&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
              &nbsp; 安卓版下载&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
              &nbsp;苹果版下载</span
            >
          </p>
          <p class="MsoNormal" style="text-indent: 21pt">
            &emsp;&emsp;<span></span>
          </p>
          <p
            class="MsoNormal"
            style="text-align: left; margin-left: 0cm; text-indent: 0cm"
          >
            &emsp;&emsp;<b
              ><span style="font-size: 14px"
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2.&nbsp;
              </span></b
            ><b
              ><span style="font-size: 14px">应用商店下载</span
              ><span style="font-size: 14px">:</span></b
            >
          </p>
          <p class="MsoNormal" style="text-align: left; text-indent: 38pt">
            &emsp;&emsp;<span style="font-size: 14px"
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;安卓手机打开应用宝</span
            ><span style="font-size: 14px">/</span
            ><span style="font-size: 14px"
              >手机自带得应用商城，搜索“药聚多”“汉宁业务员”下载即可。</span
            ><span></span>
          </p>
          <p class="MsoNormal" style="text-align: left; text-indent: 38pt">
            &emsp;&emsp;<span style="font-size: 14px"
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;苹果手机打开“</span
            ><span style="font-size: 14px">APP Store</span
            ><span style="font-size: 14px"
              >”搜索“药聚多”“汉宁业务版”下载即可。</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            style="text-align: left; margin-left: 0cm; text-indent: 0cm"
          >
            &emsp;&emsp;<span style="font-size: 16px"
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;二、注册与登录</span
            ><span></span>
          </p>
          <p class="MsoNormal" style="text-align: left">
            &emsp;&emsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
              style="font-size: 14px"
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              &nbsp; &nbsp;
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;●&nbsp;如果您有药聚多、业务员账号，在进入</span
            ><span style="font-size: 14px">APP</span
            ><span style="font-size: 14px">后，输入账号、密码即可登录。</span>
          </p>
          <p class="MsoNormal" style="text-align: left">
            &emsp;&emsp;<span
              ><span style="font-size: 14px"
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
              ><span style="font-size: 14px"
                >●&nbsp;如用户没有业务员账号，拨打咨询电话</span
              ></span
            ><span
              ><span style="font-size: 14px">: </span
              ><u><span style="font-size: 14px">13146135563</span></u></span
            ><span style="font-size: 14px">。</span>
          </p>
          <p class="MsoNormal" style="text-align: left">
            &emsp;&emsp;<span
              ><span style="font-size: 14px"
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
              ><span style="font-size: 14px"
                >●&nbsp;如用户没有药聚多账号，则在登录页面点击右上角按钮填写相关信息进行注册，如下图所示：</span
              ></span
            >
          </p>
          <p class="MsoNormal" style="text-indent: 9.5pt">
            &emsp;&emsp;<span></span>
          </p>
          <div style="text-align: center">
            &emsp;&emsp;<img
              src="https://www.yaojuduo.com/HyeyUserModule/UploadFiles/image/20190415/20190415113602_7206.jpg"
              alt=""
            />&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            <img
              src="https://www.yaojuduo.com/HyeyUserModule/UploadFiles/image/20190415/20190415113611_1120.jpg"
              alt=""
            />
          </div>
          <p style="text-align: left">&emsp;&emsp;<br /></p>
          <p class="MsoNormal" style="text-indent: 21pt">
            &emsp;&emsp;<span></span>
          </p>
          <p class="MsoNormal" style="text-align: left; text-indent: 9.5pt">
            &emsp;&emsp;<span style="color: #e53333"
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注</span
            ><span style="color: #e53333">:</span
            ><span style="color: #e53333">游客登录看不到价格。</span>
          </p>
          <p class="MsoNormal" style="text-align: left">
            &emsp;&emsp;<span style="font-size: 16px"
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;三、如何下单</span
            >
          </p>
          <p class="MsoNormal" style="text-align: left; text-indent: 14pt">
            &emsp;&emsp;<b
              ><span style="font-size: 14px"
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.</span
              ></b
            ><span style="font-size: 14px"
              >进入首页，可通过商品名称搜索、开始采购等进入药品列表页。或直接点击底部的</span
            ><span style="font-size: 14px">“</span
            ><span style="font-size: 14px">分类</span
            ><span style="font-size: 14px">”</span
            ><span style="font-size: 14px">，进行选</span>
          </p>
          <p class="MsoNormal" style="text-align: left; text-indent: 14pt">
            &emsp;&emsp;<span style="font-size: 14px"
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;购。如下图</span
            ><span style="font-size: 14px">&nbsp;所示：</span>
          </p>
          <div style="text-align: center">
            &emsp;&emsp;<img
              src="https://www.yaojuduo.com/HyeyUserModule/UploadFiles/image/20190415/20190415113744_3954.jpg"
              alt=""
            />&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            &nbsp;&nbsp;<img
              src="https://www.yaojuduo.com/HyeyUserModule/UploadFiles/image/20190415/20190415113752_0228.jpg"
              alt=""
            />
          </div>
          <p style="text-align: left">&emsp;&emsp;<br /></p>
          <p class="MsoNormal" style="text-indent: 21pt">
            &emsp;&emsp;<span></span>
          </p>
          <p style="text-align: left; background: white">
            &emsp;&emsp;<b
              ><span style="font-size: 14px"
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2.</span
              ></b
            ><span style="font-size: 14px"
              >在药品页选择药品和药品数量。根据不同类别选择需要药品（注意药品包装规格），点击加号和减号可以增减</span
            >
          </p>
          <p style="text-align: left; background: white">
            &emsp;&emsp;<span style="font-size: 14px"
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;数量，点</span
            >
          </p>
          <p style="text-align: left; background: white">
            &emsp;&emsp;<span style="font-size: 14px"
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;击中间数字也可以直接输入数量，数量修改完后点击“加入购物车”如下图所示：</span
            ><span></span>
          </p>
          <div style="text-align: center">
            &emsp;&emsp;<img
              src="https://www.yaojuduo.com/HyeyUserModule/UploadFiles/image/20190415/20190415113844_7748.jpg"
              alt=""
            />&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            &nbsp; &nbsp; &nbsp;&nbsp;<img
              src="https://www.yaojuduo.com/HyeyUserModule/UploadFiles/image/20190415/20190415113855_1094.jpg"
              alt=""
            />
          </div>
          <p style="text-align: left">&emsp;&emsp;<br /></p>
          <p class="MsoNormal" style="text-indent: 21pt">
            &emsp;&emsp;<span></span>
          </p>
          <p class="MsoNormal" align="left" style="text-align: left">
            &emsp;&emsp;<b
              ><span style="font-size: 14px"
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.</span
              ></b
            ><span style="font-size: 14px">选好药品后选择</span
            ><span style="font-size: 14px">“</span
            ><span style="font-size: 14px">购物车</span
            ><span style="font-size: 14px">”</span
            ><span style="font-size: 14px">，进入</span
            ><span style="font-size: 14px">“</span
            ><span style="font-size: 14px">购物车</span
            ><span style="font-size: 14px">”</span
            ><span style="font-size: 14px"
              >页面。核对所选药品是否正确，包含名字、数量、规格。如下图所示：&nbsp;
              &nbsp;&nbsp;</span
            >
          </p>
          <p class="MsoNormal" align="left" style="text-align: left">
            &emsp;&emsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<img
              src="https://www.yaojuduo.com/HyeyUserModule/UploadFiles/image/20190415/20190415113951_6296.jpg"
              alt=""
            />
          </p>
          <p style="text-align: left">&emsp;&emsp;<br /></p>
          <p class="MsoNormal" style="text-indent: 21pt">
            &emsp;&emsp;<span></span>
          </p>
          <p class="MsoNormal" align="left" style="text-align: left">
            &emsp;&emsp;<b
              ><span style="font-size: 14px"
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4.</span
              ></b
            ><span style="font-size: 14px">核实无误后点击</span
            ><span style="font-size: 14px">“</span
            ><span style="font-size: 14px">提交订单</span
            ><span style="font-size: 14px">”</span
            ><span style="font-size: 14px"
              >进入下一界面，核实联系人信息、支付方式后，点击</span
            ><span style="font-size: 14px">“</span
            ><span style="font-size: 14px">提交订单</span
            ><span style="font-size: 14px">”</span
            ><span style="font-size: 14px">，下单成功。如下图</span
            ><span style="font-size: 14px">所示：</span>
          </p>
          <div style="text-align: center">
            &emsp;&emsp;<img
              src="https://www.yaojuduo.com/HyeyUserModule/UploadFiles/image/20190415/20190415114043_1536.jpg"
              alt=""
            />&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            &nbsp; &nbsp;<img
              src="https://www.yaojuduo.com/HyeyUserModule/UploadFiles/image/20190415/20190415114052_6601.jpg"
              alt=""
            />
          </div>
          <p style="text-align: left">&emsp;&emsp;<br /></p>
          <p class="MsoNormal" style="text-indent: 21pt">
            &emsp;&emsp;<span></span>
          </p>
          <p class="MsoNormal" style="text-align: left">
            &emsp;&emsp;<span style="font-size: 16px"
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;四、订单查询</span
            >
          </p>
          <span style="font-size: 14px">
            <div style="text-align: left">
              &emsp;&emsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b
                ><span style="font-size: 14px"
                  >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.</span
                ></b
              >点击下方模块中的“订单”在“我的订单”中点击订单可查看订单信息，如下图所示:&nbsp;&nbsp;
            </div>
          </span>
          <p class="MsoNormal" style="text-align: center; text-indent: 21pt">
            &emsp;&emsp;<span>
              <img
                src="https://www.yaojuduo.com/HyeyUserModule/UploadFiles/image/20190415/20190415114145_0161.jpg"
                alt=""
              />&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
              &nbsp;&nbsp;<img
                src="https://www.yaojuduo.com/HyeyUserModule/UploadFiles/image/20190415/20190415114152_6196.jpg"
                alt=""
              /><br />
            </span>
          </p>
          <p style="text-align: left">&emsp;&emsp;<br /></p>
          <br />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Help'
}
</script>
